import { ConfigurationRight } from '../../../interfaces/ConfigurationRight';
import Store from '../../../interfaces/Store';
import update from 'immutability-helper';

export const setConfigurationRightsReducer = (
  state: Store,
  configurationRights: ConfigurationRight[]
): Store => {
  return update(state, {
    rights: {
      edit: {
        $set: configurationRights.includes(ConfigurationRight.WRITE)
      },
      request: {
        $set: configurationRights.includes(ConfigurationRight.REQUEST)
      }
    }
  });
};
